import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Auth.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (data.success) {
        setMessage(data.message);
        setEmail('');
      } else {
        setError(data.message || 'Failed to send reset email');
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page-container">
      <div className="auth-page-main">
        <div className="auth-page-box">
          <Link to="/signin" className="auth-page-back-link">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Back to Sign In
          </Link>
          <div className="auth-page-header">
            <h2 className="auth-page-title">Forgot Password</h2>
            <p className="auth-page-form-hint" style={{ marginTop: '0.5rem', textAlign: 'center' }}>
              Enter your email address and we'll send you a link to reset your password.
            </p>
          </div>

          <form className="auth-page-form" onSubmit={handleSubmit}>
            {message && (
              <div className="auth-page-success">
                {message}
              </div>
            )}

            {error && (
              <div className="auth-page-error">
                {error}
              </div>
            )}

            <div className="auth-page-form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="Enter your email"
                disabled={loading}
                autoComplete="email"
              />
            </div>

            <button type="submit" className="auth-page-button" disabled={loading}>
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>

          <div className="auth-page-footer">
            <p>
              Remember your password?{' '}
              <Link to="/signin" className="auth-page-link">
                Sign in
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
